'use client'

import { useEffect } from 'react'
import { useAppDispatch, useInjectPageReducer } from '@app/model/store/client'

import PageLayout from '@app/PageLayout/PageLayout'

import { initSelectionItem } from '@pages/SelectionItem/model/actions'
import SelectionItemReducer, { resetState } from '@pages/SelectionItem/model/slice'
import SelectionItem from '@pages/SelectionItem'
import type { SelectionItemPageClientProps } from '@pages/SelectionItem'

import { BlockBoundary } from '@shared/lib/components/BlockBoundary'

const CURRENT_PAGE = 'selection_item'

export default function SelectionItemPageClient({ global_data, data, breadcrumbItems }: SelectionItemPageClientProps) {
  useInjectPageReducer('selection_item', SelectionItemReducer)

  const dispatch = useAppDispatch()

  useEffect(() => {
    dispatch(initSelectionItem(data))

    return () => {
      dispatch(resetState())
    }
  }, [data, dispatch])

  return (
    <BlockBoundary>
      <PageLayout globalData={global_data} currentPage={CURRENT_PAGE} breadcrumbItems={breadcrumbItems}>
        <SelectionItem initialData={data} />
      </PageLayout>
    </BlockBoundary>
  )
}
